import React, { useState, useEffect } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices } from 'hook/services';
import Editor from 'components/editor';
import { Autocomplete, TextField, InputAdornment, Avatar, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const EditModal = ({ data, handleRefresh, categories }) => {
  console.log(data, "data")
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [description, setDescription] = useState(data?.description || '');
  const [selectedApp, setSelectedApp] = useState(data?.app || null);
  const [roadmapType, setRoadmapType] = useState(data?.roadmap_type || 'apps');
  const [assignees, setAssignees] = useState(data?.assignees || []);
  const [assigneeList, setAssigneeList] = useState([]);
  const [assigneeLoading, setAssigneeLoading] = useState(false);
  const [startDate, setStartDate] = useState(data?.start_date || '');
  const [endDate, setEndDate] = useState(data?.end_date || '');

  useEffect(() => {
    if (data) {
      setDescription(data.description || '');
      setSelectedApp(data.app || null);
      setRoadmapType(data.roadmap_type || 'apps');
      setAssignees(data.assignees || []);
      setStartDate(data.start_date || '');
      setEndDate(data.end_date || '');
    }
  }, [data]);

  const handleModal = async () => {
    setOpenEditProduct(true);
    setAssigneeLoading(true);
    const { response } = await AppService.user.GetTeam({ toaster: false });

    if (response) {
      setAssigneeList(response.data || []);
    } else {
      setAssigneeList([]);
    }
    setAssigneeLoading(false);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
    setAssignees([]);
    setAssigneeList([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    const payload = {
      _id: data._id,
      name: e.target.name.value,
      description: description,
      status: e.target.status.value,
      start_date: e.target.start_date.value,
      end_date: e.target.end_date.value,
      version_type: "V3",
      app: selectedApp,
      roadmap_type: roadmapType,
      assignees: assignees.map(a => ({ id: a._id, name: a.name })),
    };

    if (roadmapType !== 'apps') {
      payload.video_url = e.target.video_url?.value;
    }

    const { response } = await AppService.roadmap.update({ payload });

    if (response) {
      setProcessing(false);
      closeEditProduct();
      handleRefresh();
    } else {
      setProcessing(false);
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  const status = [
    { value: 'wish_list', label: 'Wish List' },
    { value: 'planned', label: 'planned' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'testing', label: 'Testing' },
    { value: 'completed', label: 'Completed' },
  ];

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Edit Road Map
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput
                label="Name"
                name="name"
                fullWidth
                required
                defaultValue={data?.name || ''}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Select App</MDTypography>
              <Autocomplete
                fullWidth
                options={categories}
                getOptionLabel={(option) => option.app_name || option.name || ''}
                value={selectedApp}
                onChange={(event, newValue) => {
                  setSelectedApp(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search app..."
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </MDBox>
            {/* 
            <MDBox mb={2}>
              <MDTypography variant="button">Select App</MDTypography>
              <Autocomplete
                fullWidth
                options={categories}
                getOptionLabel={(option) => option.name}
                value={selectedApp}
                onChange={(event, newValue) => {
                  setSelectedApp(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search app..."
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </MDBox> */}

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} data={description} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Assignees</MDTypography>
              <Autocomplete
                multiple
                fullWidth
                options={assigneeList}
                loading={assigneeLoading}
                getOptionLabel={(option) => option.name}
                value={assignees}
                onChange={(event, newValue) => setAssignees(newValue)}
                renderOption={(props, option) => (
                  <li {...props} key={option._id}>
                    <Avatar src={option.image} sx={{ width: 24, height: 24, mr: 1 }} />
                    {option.username} ({option.email})
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select assignees"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                          {params.InputProps.startAdornment}
                        </>
                      ),
                      endAdornment: (
                        <>
                          {assigneeLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Roadmap Type</MDTypography>
              <MDInput
                select
                name="roadmap_type"
                fullWidth
                required
                SelectProps={{ native: true }}
                value={roadmapType}
                onChange={(e) => setRoadmapType(e.target.value)}
              >
                <option value="apps">Apps</option>
                <option value="all_the_apps">All the Apps</option>
                <option value="all_the_apps_agency">All the Apps Agency</option>
                <option value="all_the_apps_ai">All the Apps AI</option>
                <option value="app_creater">App Creater</option>
              </MDInput>
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Start Date</MDTypography>
              <MDInput
                label="Start Date"
                name="start_date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                required
                defaultValue={startDate}
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">End Date</MDTypography>
              <MDInput
                label="End Date"
                name="end_date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                required
                defaultValue={endDate}
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
              />
            </MDBox>

            {roadmapType !== 'apps' && (
              <MDBox mb={2}>
                <MDTypography variant="button">Video URL</MDTypography>
                <MDInput
                  label="Video URL"
                  name="video_url"
                  required
                  fullWidth
                  defaultValue={data?.video_url || ''}
                />
              </MDBox>
            )}

            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput
                select
                name="status"
                fullWidth
                required
                SelectProps={{ native: true }}
                defaultValue={data?.status || ''}
              >
                {status.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </MDInput>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;